import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgForceLayout = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 65 38"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M10.035 1.199a2 2 0 0 1 2 2v1.683l.021.015c6.577 4.986 10.016 9.616 10.262 13.927h3.717v-1.625a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.626l.013-.001h3.373c.065 0 .127.012.183.034.228-4.32 3.668-8.962 10.262-13.961a.499.499 0 0 1 .169-.084V3.2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V6.027c-6.396 4.94-9.524 9.435-9.443 13.448.073 3.643 1.42 6.14 4.512 8.99l.438.396.469.41.51.433.56.466.623.507 2.33 1.868v-1.346a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-1.373l-3.59-2.886-.57-.473-.52-.442-.479-.419-.448-.406c-3.278-3.02-4.755-5.76-4.835-9.705l.01.295a.496.496 0 0 1-.09.026l-.09.008h-3.374l-.013-.001v1.376a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-1.375H22.32l-.001.037c-.162 3.75-1.648 6.414-4.823 9.34l-.448.405-.48.42-.52.44-.57.474-3.443 2.768v1.49a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.229l2.184-1.75.622-.507.56-.466.51-.433.47-.41.437-.396c3.093-2.85 4.439-5.347 4.513-8.99.08-3.982-2.999-8.438-9.295-13.333l-.001 1.057a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h8Zm0 29.2h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .793-.7l.007-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Zm52 0h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .793-.7l.007-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Zm-52-28h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .793-.7l.007-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Zm52 0h-8a.8.8 0 0 0-.794.7l-.006.1v4a.8.8 0 0 0 .7.793l.1.007h8a.8.8 0 0 0 .793-.7l.007-.1v-4a.8.8 0 0 0-.7-.794l-.1-.006Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgForceLayout)
const Memo = memo(ForwardRef)
export default Memo
